import React, {useEffect, useRef} from 'react';
import {SteppedEase, TweenMax} from "gsap";

const ScrollIcon = (props) => {

    const swipe = useRef();

    useEffect(()=>{

        setTimeout(()=>{

            if(swipe.current){

                let signatureDuration = 1.5;

                let height = 3800;
                TweenMax.to(swipe.current,signatureDuration,{
                    backgroundPosition: `0 -${height}px`,ease:SteppedEase.config(76),
                    repeat:-1,
                    repeatDelay: 1
                });

                /** hard set at end of animation for resizers **/
                setTimeout(()=>{
                    if(swipe.current) swipe.current.style.backgroundPosition= 'center bottom';
                },signatureDuration + 200)

            }


        }, 0);

    }, [])

    let newSrc = 'https://msobd-storage.azureedge.net/images/telephone/SwipeIcon_Sprite_v1.png';

    let style = {
        backgroundImage: `url(${newSrc})`,
        width: '50px',
        height: '50px',
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 999,
        backgroundSize: '100%'
    }

    return (
        <div ref={swipe} style={style}/>
    )
};

export default ScrollIcon
